import React from "react";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <section className="bg-royal-blue text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-kingdom-gold font-semibold uppercase tracking-widest text-sm">Public Terms</p>
          <h1 className="font-heading text-4xl md:text-5xl mt-3">Terms of Service</h1>
          <p className="mt-4 text-slate-200">The Kingdom of Yunah'Shach'Qal Yashar'al · gov.yasharal.vip</p>
          <p className="mt-2 text-sm text-slate-300">Effective: August 31, 2026</p>
        </div>
      </section>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-10 leading-7">
        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">1. Acceptance</h2>
          <p>By using gov.yasharal.vip, Nation Studio, Nation communications, recordings, live-streaming tools, or related portal services, you agree to these Terms as they apply to your use of those services.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">2. Accounts and access</h2>
          <p>Users must use accounts they are authorized to access and must not share credentials in a way that defeats Nation access controls. Hosts and co-hosts are responsible for choosing appropriate participants, functions, guests, and public destinations for each session.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">3. Nation Studio and connected social accounts</h2>
          <p>Nation Studio may connect to supported social platforms so an authorized user can broadcast to selected destinations. Users are responsible for having permission to control the connected channel, Page, or account and for complying with that platform's own terms and community rules.</p>
          <p className="mt-3">Nation Studio does not request or store social-media passwords. Connections use provider authorization tokens or, where a platform requires it, advanced streaming credentials supplied by the account owner.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">4. Meetings, recording, and broadcasting</h2>
          <p>Hosts may conduct private meetings, recordings, or public broadcasts. Hosts are responsible for making recording or public-broadcast status clear to participants and for obtaining any consent required by applicable law before recording voices, images, screens, or other content.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">5. Content and permissions</h2>
          <p>You may upload, present, record, or broadcast only content you are authorized to use. You retain responsibility for your content and grant the service only the technical permission necessary to store, transmit, render, record, or publish it according to the features you choose.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">6. Prohibited use</h2>
          <p>Do not use the services to gain unauthorized access, interfere with system security, impersonate another account holder, distribute malicious code, abuse participants, or intentionally violate the rights of others or the rules of a connected platform.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">7. Availability and changes</h2>
          <p>Features may depend on hosting, browsers, device permissions, network conditions, self-hosted media infrastructure, storage, or third-party APIs. We may improve, restrict, replace, or discontinue features when needed for security, reliability, provider changes, or Nation operations.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">8. Third-party destinations</h2>
          <p>When you choose YouTube, Facebook, TikTok, Instagram, X, or another destination, that platform independently processes the program output and related account information under its own terms and privacy policy. Nation Studio does not control how a third-party platform handles a broadcast after it is delivered there.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">9. Suspension or termination</h2>
          <p>Access may be suspended or terminated for security reasons, misuse, loss of authorization, violation of Nation access rules, or other conduct that threatens users, infrastructure, or lawful operation of the service.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">10. Disclaimers</h2>
          <p>The service is provided on an as-available basis. We work to protect and maintain the system, but cannot guarantee uninterrupted availability or that every third-party provider will continue to expose the same streaming capabilities.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-royal-blue mb-3">11. Contact</h2>
          <p>Questions about these Terms may be sent to <a className="text-royal-blue underline" href="mailto:admin@yasharal.vip">admin@yasharal.vip</a>.</p>
        </section>

        <div className="pt-6 border-t border-slate-200 flex flex-wrap gap-4 text-sm">
          <Link className="text-royal-blue underline" to="/privacy">Privacy Policy</Link>
          <Link className="text-royal-blue underline" to="/contact">Contact</Link>
          <Link className="text-royal-blue underline" to="/">Home</Link>
        </div>
      </main>
    </div>
  );
}
